import "whatwg-fetch"; // polyfill for older browsers

import {
  getAPIConfig,
  handleAPIResponse,
  convertQueryObjToString,
} from "@utils/browser-helpers";
import { executeAPIRequest } from "@adapters/api";

export default {
  fetchDeviceSegments: async (query = "") => {
    let route = `/device_segments${convertQueryObjToString(query)}`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData, []);
  },

  logout: async () => {
    const apiConfig = getAPIConfig("/logout", false, false, true);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  fetchAllStores: async (query = "") => {
    let route = `/stores${query}`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    try {
      let responseData = await response.json();
      responseData = handleAPIResponse(responseData);
      let stores = responseData.stores
        ? [...responseData.stores]
        : responseData;
      return stores;
    } catch (err) {
      console.log("Error fetching all stores.", err);
      return [];
    }
  },

  fetchLocationGroups: async (query = "") => {
    const apiConfig = getAPIConfig(`/location_groups${query}`);
    const response = await executeAPIRequest(apiConfig, "GET");
    try {
      let responseData = await response.json();
      responseData = handleAPIResponse(responseData);
      let locationGroups = responseData.location_groups
        ? [...responseData.location_groups]
        : responseData;
      return locationGroups;
    } catch (err) {
      console.log("Error fetching all location groups.", err);
      return [];
    }
  },

  fetchGeocoordinates: async (addressObj) => {
    const apiConfig = getAPIConfig("/geocoordinates");
    const response = await executeAPIRequest(
      apiConfig,
      "POST",
      null,
      addressObj
    );
    const responseData = await response.json();
    try {
      return handleAPIResponse(responseData);
    } catch (err) {
      console.warn("Error getting geocoordinates.", err);
      return err;
    }
  },

  saveBulkStoreUploadFile: async (fileData) => {
    let route = `/stores/bulk_upload`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "POST", null, fileData);
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  fetchGeoLocations: async (query = "") => {
    let route = `/geo${convertQueryObjToString(query)}`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData, []);
  },

  createGeoSegment: async (segmentInfo) => {
    let route = `/device_segments/geo_segment`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(
      apiConfig,
      "POST",
      null,
      segmentInfo
    );
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  getMaintenanceModeStatus: async () => {
    let route = `/maintenance_windows`;
    const apiConfig = getAPIConfig(route, false, true);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  createMaintenanceModeSession: async (maintenceModeDetails) => {
    let route = `/maintenance_windows`;
    const apiConfig = getAPIConfig(route, false, true);
    const response = await executeAPIRequest(
      apiConfig,
      "PUT",
      null,
      maintenceModeDetails
    );
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  activateMaintenanceModeSession: async (maintenceModeDetails) => {
    let route = `/maintenance_windows`;
    const apiConfig = getAPIConfig(route, false, true);
    const response = await executeAPIRequest(
      apiConfig,
      "POST",
      null,
      maintenceModeDetails
    );
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  getMaintenanceModeClientList: async (query) => {
    let route = `/affected_clients${convertQueryObjToString(query)}`;
    const apiConfig = getAPIConfig(route, false, true);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
};
